import axios from 'axios';
import { API_CONFIG } from '../config/api.config';
import { AuthService } from './auth.service';

const uploadInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
});

uploadInstance.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

uploadInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      AuthService.logout();
      window.location.href = '/auth/sign-in';
    }
    return Promise.reject(error);
  }
);

export const uploadCardImage = async (file) => {
  const formData = new FormData();
  formData.append('image', file);

  const response = await uploadInstance.post(
    API_CONFIG.ENDPOINTS.UPLOAD.CARD_IMAGE,
    formData
  );

  return response.data.url;
};
